import {useMediaQuery} from '@mui/material'

import {hpFundamentalDarkTheme, hpFundamentalLightTheme} from './themeConfig'
import {ThemeMode} from './themeSettings.types'
import {useThemeSettings} from './ThemeSettingsProvider'

/**
 * Returns the Fundamental-aligned MUI theme (light or dark) based on the current
 * theme mode from `ThemeSettingsProvider`. Use inside features so their MUI
 * subtree follows the same light/dark choice as the Suite shell.
 */
export const useFundamentalMuiTheme = () => {
  const {themeMode} = useThemeSettings()
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)')

  const selectedMode =
    themeMode === ThemeMode.Device
      ? prefersDarkMode
        ? ThemeMode.Dark
        : ThemeMode.Light
      : themeMode

  return selectedMode === ThemeMode.Dark ? hpFundamentalDarkTheme : hpFundamentalLightTheme
}
